import { render, staticRenderFns } from "./NavFooter.vue?vue&type=template&id=2c6bffe4&scoped=true&"
import script from "./NavFooter.vue?vue&type=script&lang=js&"
export * from "./NavFooter.vue?vue&type=script&lang=js&"
import style0 from "./NavFooter.vue?vue&type=style&index=0&id=2c6bffe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6bffe4",
  null
  
)

export default component.exports